module.exports = __webpack_public_path__ + "static/media/otherShipping.1bc80431.png";